import React from 'react';
import { Header } from '../components/global/header';
import { Register } from '../components/auth/register';
import { Footer } from '../components/global/footer';


const RegisterPage = () => {
  return (
    <div>
        <Header />
        <Register />
        <Footer />
    </div>
  );
};

export default RegisterPage;